import { createReducer } from 'reduxsauce';
import { createSelector } from 'reselect';
import Immutable from 'seamless-immutable';
import { ResetPasswordTypes } from '../actions/ResetPasswordActions';
import { isValidEmail, isEmpty } from '../../services/Validation';

/* ------------- Initial ResetPassword State ------------- */
export const INITIAL_STATE = Immutable({
  error: '',
  errorCode: null,
  fetching: false,
  email: '',
  showEmailError: false,
  reset: false,
  resetInitiated: false,
  newPassword: '',
  showNewPasswordError: false,
  confirmNewPassword: '',
  showConfirmNewPasswordError: false,
});

/* ------------- Reducers ------------- */
export const onRequest = state =>
  state.merge({ fetching: true, resetInitiated: false, reset: false });
export const onFailure = (state, { error, errorCode }) =>
  state.merge({ fetching: false, error, errorCode });
export const onInitResetPasswordSuccess = state =>
  state.merge({ fetching: false, resetInitiated: true });
export const onFinishResetPasswordSuccess = state =>
  state.merge({ fetching: false, reset: true });
export const onEmailChange = (state, { email }) =>
  state.merge({ email, showEmailError: true });
export const onNewPasswordChange = (state, { newPassword }) =>
  state.merge({ newPassword, showNewPasswordError: true });
export const onConfirmNewPasswordChange = (state, { confirmNewPassword }) =>
  state.merge({ confirmNewPassword, showConfirmNewPasswordError: true });
export const onClear = () => INITIAL_STATE;

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
  [ResetPasswordTypes.INIT_RESET_PASSWORD_REQUEST]: onRequest,
  [ResetPasswordTypes.INIT_RESET_PASSWORD_SUCCESS]: onInitResetPasswordSuccess,
  [ResetPasswordTypes.INIT_RESET_PASSWORD_FAILURE]: onFailure,
  [ResetPasswordTypes.FINISH_RESET_PASSWORD_REQUEST]: onRequest,
  [ResetPasswordTypes.FINISH_RESET_PASSWORD_SUCCESS]: onFinishResetPasswordSuccess,
  [ResetPasswordTypes.FINISH_RESET_PASSWORD_FAILURE]: onFailure,
  [ResetPasswordTypes.EMAIL_CHANGED]: onEmailChange,
  [ResetPasswordTypes.NEW_PASSWORD_CHANGED]: onNewPasswordChange,
  [ResetPasswordTypes.CONFIRM_NEW_PASSWORD_CHANGED]: onConfirmNewPasswordChange,
  [ResetPasswordTypes.CLEAR_RESET_PASSWORD]: onClear,
});

/* ------------- Selectors ------------- */
export const isFetching = state => state.resetPassword.fetching;
export const isResetInitiated = state => state.resetPassword.resetInitiated;
export const isReset = state => state.resetPassword.reset;
export const getError = state => state.resetPassword.error;
export const getErrorCode = state => state.resetPassword.errorCode;
export const getEmail = state => state.resetPassword.email;
export const shouldShowEmailError = state => state.resetPassword.showEmailError;
export const getNewPassword = state => state.resetPassword.newPassword;
export const getConfirmNewPassword = state =>
  state.resetPassword.confirmNewPassword;
export const shouldShowNewPasswordError = state =>
  state.resetPassword.showNewPasswordError;
export const shouldShowConfirmNewPasswordError = state =>
  state.resetPassword.showConfirmNewPasswordError;

// memoized
export const getEmailError = createSelector(getEmail, email =>
  isValidEmail(email) ? '' : 'A valid email address is required'
);
export const canInitiateResetPassword = createSelector(
  [getEmailError, isFetching],
  (emailError, fetching) => !fetching && emailError.length === 0
);
export const getNewPasswordError = createSelector(getNewPassword, password =>
  isEmpty(password) ? 'Password is required' : ''
);
export const getConfirmNewPasswordError = createSelector(
  [getConfirmNewPassword, getNewPassword],
  (confirmPassword, password) => {
    if (isEmpty(confirmPassword)) return 'Confirmation password is required';
    if (password !== confirmPassword) return 'Passwords must match';
    return '';
  }
);
export const canFinishResetPassword = createSelector(
  [getConfirmNewPasswordError, isFetching],
  (passwordError, fetching) => !fetching && passwordError.length === 0
);



// WEBPACK FOOTER //
// ./src/state/reducers/ResetPasswordReducer.js